"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Extend the base Message class to create your own Custom messages
 */
class AbstractMessage {
    /**
     * Get parent class name as message Subject
     */
    getSubject() {
        return this.constructor.name;
    }
}
exports.default = AbstractMessage;
//# sourceMappingURL=AbstractMessage.js.map